module.exports = __webpack_public_path__ + "assets/img/thumb-Aussie-Broadband-eBook.c3b12106.png";